export const ActionTypes = {
  SET_REPORTS: 'SET_REPORTS',
  UPDATE_REPORT: 'UPDATE_REPORT',
  TOGGLE_REPORT_MODAL: 'TOGGLE_REPORT_MODAL',
  SET_SELECTED_REPORT: 'SET_SELECTED_REPORT',
  SET_SELECTED_REPORT_REPORTERS: 'SET_SELECTED_REPORT_REPORTERS',
};
